'use strict';

export default function(data) {
	return {
		...data,
		userMessage     : getUserMessage(data),
		errorCode       : getErrorCode(data)
	};
}

/*
 * Helpers
 */

function getUserMessage(data) {
	if (data.message && data.message.length) {
		return data.message[0].user_msg;
	}
	return 'Oops, something went wrong. Feel free to try again while we investiage the issue.';
}

function getErrorCode(data) {
	if (data.message && data.message.length) {
		if (data.message[0].code) {
			return data.message[0].code;
		}
	} else if(data.error && data.error.length) {
		return data.error;
	}
	return 'Unknown Api Error Code';
}


// WEBPACK FOOTER //
// ./src/frontend-standard-library/modules-react/Base/Model/httpErrorModelFactory.js